import React, { useState, useEffect } from 'react';
import { css } from '@emotion/css';
import { Subscribe } from 'unstated';
import ModalLayout from '../../components/structure/ModalLayout';
import OrganizationContainer from '../../state/containers/OrganizationContainer';
import { RouteComponentProps } from 'react-router';
import PageError from '../../components/general/PageError';
import MemberContainer from '../../state/containers/MemberContainer';
import AddApplicationMemberForm from './components/AddApplicationMemberForm';
import ApplicationMembersContainer from '../../state/containers/ApplicationMembersContainer';
import ModalHeader from '../../components/general/ModalHeader';
import CurrentApplicationContainer from '../../hooks/CurrentApplicationContainer';

interface AddApplicationMemberProps {
    applicationId: string
}

const AddApplicationMember: React.FC<RouteComponentProps<AddApplicationMemberProps>> = (props) => {
    const [hasChanges, setHasChanges] = useState(false);
    
    // Set current application ID in the container
    const currentAppContainer = CurrentApplicationContainer.useContainer();
    useEffect(() => {
        if (props.match.params.applicationId) {
            currentAppContainer.setApplicationId(props.match.params.applicationId);
        }
    }, [props.match.params.applicationId, currentAppContainer]);

    const handleClose = () => {
        if (hasChanges) {
            var confirmClose = confirm("You have unsaved changes. Are you sure you want to close?");
            if (!confirmClose)
                return;
        }
        props.history.goBack();
    };

    const handleFinish = () => {
        props.history.goBack();
    };

    const handleChange = () => {
        setHasChanges(true);
    };

    return (

        <ModalLayout
            isVisible={true}
            onClose={handleClose}
            className={modalStyle}
        >
            <Subscribe to={[MemberContainer, OrganizationContainer, ApplicationMembersContainer]}>
                {(memberContainer: MemberContainer, orgContainer: OrganizationContainer, appMemberContainer: ApplicationMembersContainer) => {
                    return (
                        <>
                            <ModalHeader title="Add a New Member" onClose={handleClose} /> 
                            <AddApplicationMemberForm
                                applicationId={props.match.params.applicationId}
                                appMemberContainer={appMemberContainer}
                                organizationContainer={orgContainer}
                                memberContainer={memberContainer}
                                onFinish={handleFinish}
                                onClose={handleClose}
                                onChange={handleChange} />
                            <PageError errors={memberContainer.state.errors} />
                        </>
                    );
                }}
            </Subscribe>
        </ModalLayout>
    );
};

const modalStyle = css`
`;

export default AddApplicationMember;